import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { forwardRef, useContext, useEffect } from "react";
import { useQuery } from "@apollo/client/react/hooks";
import { CartContext } from "lib/cartContext";

import { GetCart } from "../../../../helpers/api/cadeauConcepten/queries/cart.gql";

import { CartStyled, CartItemSkeleton } from "./Cart.styled";

const Item = dynamic(() => import("./Item/Item"));

const Cart = forwardRef(({ active, handleActive }, ref) => {
    let items = [];
    const { data, loading } = useQuery(GetCart, {
        notifyOnNetworkStatusChange: true
    });
    const {
        addingPackage,
        cartData,
        cartLoading,
        setCartData,
        setCartLoading
    } = useContext(CartContext);

    useEffect(() => {
        if (cartLoading !== loading) {
            setCartLoading(loading);
        }
        if (!loading && data) {
            setCartData(data);
        }
    }, [data, loading, cartLoading, setCartData, setCartLoading]);

    if (cartLoading && cartData?.cart?.items?.length > 0) {
        items = Array(cartData?.cart?.items?.length)
            .fill()
            // eslint-disable-next-line react/no-array-index-key
            .map((_, index) => <CartItemSkeleton key={index} />);
    }

    if (!cartLoading && cartData?.cart?.items?.length > 0) {
        items = cartData.cart.items.map((item, index) => (
            <Item
                key={item.id}
                item={item}
                index={index}
                active={active === item.id}
                handleActive={handleActive}
                onExpand={() => handleActive(item.id)}
                onCollapse={() => handleActive()}
            />
        ));
    }

    return (
        <CartStyled ref={ref}>
            {items}
            {addingPackage && <CartItemSkeleton />}
        </CartStyled>
    );
});

Cart.displayName = "Cart";

Cart.propTypes = {
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    handleActive: PropTypes.func.isRequired
};

Cart.defaultProps = {
    active: false
};

export default Cart;
